<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="店铺名称" prop="storeCode">
          <el-select v-model="searchForm.storeCode" placeholder="全部" multiple collapse-tags clearable style="width: 240px">
            <el-option v-for="item in storeList" :key="item.storeCode" :label="item.shortName" :value="item.storeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上市清单名称" prop="name">
          <el-input v-model.trim="searchForm.name" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="发布时间">
          <form-date-range
            :form="searchForm"
            startKey="dts"
            endKey="dte"
            :usingTime="false"
            valueFormat="yyyy-MM-dd"
          ></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="storeName" label="店铺名称" min-width="150"></el-table-column>
        <el-table-column prop="userName" label="负责人" min-width="120"></el-table-column>
        <el-table-column prop="name" label="上市清单名称" min-width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="goListingList(row)">{{ row.name }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="publishDate" label="清单上市时间" min-width="120"></el-table-column>
        <el-table-column prop="needQty" label="需上架商品数" min-width="120">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="goRecord(row, null)" v-if="$index > 0">{{ row.needQty }}</el-button>
            <span v-else>{{ row.needQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="waitQty" label="待上架商品数" min-width="150">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="goRecord(row, 0)" v-if="$index > 0">{{ row.waitQty }}</el-button>
            <span v-else>{{ row.waitQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cannotQty" label="暂缓上架商品数" min-width="150">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="goRecord(row, 1)" v-if="$index > 0">{{ row.cannotQty }}</el-button>
            <span v-else>{{ row.cannotQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noNeedQty" label="无需上架商品数" min-width="120">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="goRecord(row, 2)" v-if="$index > 0">{{ row.noNeedQty }}</el-button>
            <span v-else>{{ row.noNeedQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="upQty" label="已上架商品数" min-width="150">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="goRecord(row, 3)" v-if="$index > 0">{{ row.upQty }}</el-button>
            <span v-else>{{ row.upQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="finishRate" label="上架完成率" min-width="120">
          <template #header>
            <span class="header-with-tips">
              上架完成率
              <el-tooltip class="item" effect="dark" content="（无需上架商品数 + 已上架商品数） /  需上架商品数" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="daysTaken" label="完成耗时天数" min-width="120">
          <template #header>
            <span class="header-with-tips">
              完成耗时天数
              <el-tooltip class="item" effect="dark" content="（商品的完成上架时间 - 上市清单发布时间）汇总求和 / 已完成上架操作的商品数" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="goDetails(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <stroeGoodsRecord :visible.sync="isShowRecord" v-if="isShowRecord" :rowData="rowData"></stroeGoodsRecord>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import stroeGoodsRecord from './components/stroeGoodsRecord.vue';
export default {
  name: 'GoodsData',
  mixins: [tableMixin, pagePathMixin],
  components: { stroeGoodsRecord },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      isShowRecord: false,
      searchFormData: {},
      rules: {},
      rowData: {},
      searchForm: {
        name: '',
        dts: '',
        dte: '',
        storeCode: [],
        listNo: '',
      },
      storeList: [],
    };
  },
  mounted() {
    this.loading = true;
    this.getStoreList();
    setTimeout(() => {
      this.onSearch();
    }, 200);
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .listStore({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.searchForm = {
        storeCode: [],
        name: '',
        dts: '',
        dte: '',
        listNo: '',
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    goListingList(row) {
      this.$router.push({ path: '/newProduct/listingList', query: { name: row.name } });
    },

    goRecord(row, state) {
      this.rowData = {
        ...row,
        state,
      };
      this.isShowRecord = true;
    },
    goDetails(row) {
      this.$emit('goDetails',{
        storeCode: row.storeCode,
        name: row.name
      })
    },
    getStoreList() {
      let data = {
        pageNum: 1,
        pageSize: 999999,
        filterData: {
          newArrival: 1,
        },
      };
      this.searchFormData = data;
      this.$q.configurationCenter.storeManagePage({ data: data }).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'productListStatiscStoreExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}

.header-with-tips {
  display: flex;
  align-items: center;

  .el-icon-question {
    margin-left: 5px;
    color: #909399;
    cursor: pointer;
  }
}
</style>
